(function () {
  if (window.customElements && customElements.get('frete-calculator')) return;

  class FreteCalculator extends HTMLElement {
    connectedCallback() {
      this.variantId = this.dataset.variantId;
      this.form = this.querySelector('.frete-calculator__form');
      this.input = this.querySelector('input[name="cep"]');
      this.results = this.querySelector('.frete-calculator__results');
      this.submitBtn = this.querySelector('.frete-calculator__submit');

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
      if (this.input) {
        this.input.addEventListener('input', this.onCepInput.bind(this));
      }

      /* Mantem a calculadora sincronizada com a variante selecionada no
         formulario do produto (ex: ao trocar de cor/tamanho). */
      this._onVariantInputChange = this.onVariantInputChange.bind(this);
      document.addEventListener('change', this._onVariantInputChange);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this._onVariantInputChange);
    }

    onVariantInputChange(evt) {
      var target = evt.target;
      if (!target || !target.closest) return;
      var form = target.closest('product-form');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value) {
        this.variantId = idInput.value;
      }
    }

    onCepInput(evt) {
      var digits = evt.target.value.replace(/\D/g, '').slice(0, 8);
      if (digits.length > 5) {
        digits = digits.slice(0, 5) + '-' + digits.slice(5);
      }
      evt.target.value = digits;
    }

    onSubmit(evt) {
      evt.preventDefault();
      var cep = this.input.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        this.renderError('Digite um CEP válido com 8 números.');
        return;
      }
      this.calculate(cep);
    }

    calculate(cep) {
      var self = this;
      var addedTemporarily = false;

      self.setLoading(true);

      /* A Shopify exige estado (province) - e normalmente cidade - alem do CEP
         pra calcular frete no Brasil; sem isso o endpoint retorna erro 422 e
         nenhuma cotacao aparece, mesmo com a Frenet e o peso corretos. Por
         isso resolvemos o CEP pra endereco (cidade/UF) via ViaCEP antes de
         pedir o calculo do frete. */
      self
        .lookupCep(cep)
        .catch(function () {
          return null;
        })
        .then(function (address) {
          if (!address) {
            throw { userMessage: 'CEP não encontrado. Confira o número digitado.' };
          }

          return fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var existing = cart.items.filter(function (item) {
                return String(item.variant_id) === String(self.variantId);
              })[0];

              if (existing) {
                return false;
              }

              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: Number(self.variantId), quantity: 1 }] })
              }).then(function (res) {
                return res.ok;
              });
            })
            .then(function (didAdd) {
              addedTemporarily = !!didAdd;
              var params = new URLSearchParams();
              params.set('shipping_address[zip]', cep);
              params.set('shipping_address[country]', 'Brazil');
              params.set('shipping_address[province]', address.uf);
              if (address.localidade) {
                params.set('shipping_address[city]', address.localidade);
              }
              return fetch('/cart/shipping_rates.json?' + params.toString());
            })
            .then(function (res) {
              return res.ok ? res.json() : { shipping_rates: [] };
            })
            .then(function (data) {
              var cleanup = addedTemporarily
                ? fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: Number(self.variantId), quantity: 0 })
                  })
                : Promise.resolve();

              return cleanup.then(function () {
                self.renderResults(data.shipping_rates || []);
              });
            });
        })
        .catch(function (err) {
          self.renderError(
            (err && err.userMessage) ||
              'Não foi possível calcular o frete agora. Tente novamente em instantes.'
          );
        })
        .finally(function () {
          self.setLoading(false);
        });
    }

    lookupCep(cep) {
      return fetch('https://viacep.com.br/ws/' + cep + '/json/')
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (data) {
          if (!data || data.erro) return null;
          return data;
        });
    }

    renderResults(rates) {
      if (!rates.length) {
        this.results.innerHTML =
          '<p class="frete-calculator__empty">Nenhuma opção de frete encontrada para este CEP.</p>';
        return;
      }
      var self = this;
      var items = rates
        .map(function (rate) {
          var priceText = self.formatPrice(rate.price);
          var name = self.escapeHtml(rate.presentment_name || rate.name || 'Frete');
          return (
            '<li class="frete-calculator__option">' +
            '<span class="frete-calculator__option-name">' + name + '</span>' +
            '<span class="frete-calculator__option-price">' + priceText + '</span>' +
            '</li>'
          );
        })
        .join('');
      this.results.innerHTML = '<ul class="frete-calculator__list">' + items + '</ul>';
    }

    renderError(msg) {
      this.results.innerHTML = '<p class="frete-calculator__error">' + this.escapeHtml(msg) + '</p>';
    }

    formatPrice(rawPrice) {
      /* Diferente do resto da Cart Ajax API (cart.js, cart/add.js etc, que usam
         centavos), o endpoint /cart/shipping_rates.json retorna o preco de cada
         opcao de frete como string decimal na unidade normal da moeda (ex.:
         "17.15" = R$ 17,15) - confirmado com cotacoes reais da Frenet. Por isso
         aqui NAO se divide por 100. */
      var value = Number(rawPrice) || 0;
      if (value === 0) return 'Grátis';
      try {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      } catch (e) {
        return 'R$ ' + value.toFixed(2).replace('.', ',');
      }
    }

    escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    setLoading(state) {
      this.classList.toggle('is-loading', state);
      if (this.submitBtn) this.submitBtn.disabled = state;
      if (state) {
        this.results.innerHTML = '<p class="frete-calculator__loading">Calculando...</p>';
      }
    }
  }

  customElements.define('frete-calculator', FreteCalculator);
})();
